export function isDominoTask(task) {
  return String(task?.maintype || '').toLowerCase() === 'domino';
}

export function isPendingDominoTask(task) {
  return String(task?.status || '').toLowerCase() !== 'completed' && isDominoTask(task);
}
